import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import {
  buildVehicleSubmodelStylePath,
  convertSubmodelStyleToStyle,
  VehicleModel,
} from 'client/data/models/vehicle-v2';

export function StyleDataWrapperContent({ children, styleData = null }) {
  return React.cloneElement(children, { ...styleData });
}

StyleDataWrapperContent.propTypes = {
  children: PropTypes.element.isRequired,
  styleData: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    makeNiceName: PropTypes.string,
    modelNiceName: PropTypes.string,
    makeSlug: PropTypes.string,
    modelSlug: PropTypes.string,
    trimName: PropTypes.string,
    year: PropTypes.number,
    submodels: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  }),
};

export const stateToPropsConfig = {
  styleData: bindToPath(
    ({ styleId = null, submodel = null }) => buildVehicleSubmodelStylePath({ styleId, submodel }),
    VehicleModel,
    convertSubmodelStyleToStyle
  ),
};

export const StyleDataWrapper = connectToModel(StyleDataWrapperContent, stateToPropsConfig);

StyleDataWrapper.propTypes = {
  styleId: PropTypes.string,
  submodel: PropTypes.string,
};
